exports.components = {
  "component---cache-caches-gatsby-plugin-offline-app-shell-js": () => import("./../../caches/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---cache-caches-gatsby-plugin-offline-app-shell-js" */),
  "component---src-templates-language-tsx": () => import("./../../../src/templates/Language.tsx" /* webpackChunkName: "component---src-templates-language-tsx" */),
  "component---src-templates-languages-tsx": () => import("./../../../src/templates/Languages.tsx" /* webpackChunkName: "component---src-templates-languages-tsx" */)
}

